import Breadcrumb from "../../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import { Button, Box, Paper } from "@mui/material";
import useAbacAppState from "./State/AbacAppsState";
import { PageContainer } from "../../../App/Components/PageContainer/PageContainer";
import SortableTable from "../../../App/Components/Table/SortableTable";
import AppsTableCell from "./Components/AppsTableCell";
import { useFlags } from "launchdarkly-react-client-sdk";
import { FeatureFlags } from "../../../App/Typings/FeatureFlags";
import Modal from "../../../App/Components/Modals/Modal";
import CreateAppForm from "./Components/CreateAppForm";
import ModalForm from "../../../App/Components/Modals/Components/ModalForm";
import { useModalHooks } from "../../../App/State/Hooks/useModalHooks";

export default function AppsPage() {
  const {
    getters: {
      apps,
      columns,
      isLoading,
      createAppModalTitle,
      createIsLoading,
      formik,
    },
    handlers: { handleCreateModalClose },
  } = useAbacAppState();
  const { modalStatus, openModal } = useModalHooks();

  // Initialize EnableABACApplicationManagement LD flag
  // TODO: Remove with ABAC-32
  const { enableAbacApplicationManagement } = useFlags<FeatureFlags>();

  return (
    enableAbacApplicationManagement && (
      <>
        <PageContainer>
          <Breadcrumb pageTitle={null} />
          <h1 className="page-title">ABAC Applications</h1>
          <Paper sx={{ mt: 4, p: { xs: 2, lg: 4 } }}>
            <Box>
              <Box
                sx={{
                  width: "100%",
                  position: "relative",
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  sx={{
                    position: "absolute",
                    right: "0px",
                    top: "0px",
                    left: { xs: "0px", sm: "unset" },
                  }}
                  onClick={() => openModal()}
                >
                  Create Application
                </Button>
              </Box>
              <Box
                sx={{
                  pt: { xs: "3rem", sm: "unset" },
                }}
              >
                <SortableTable
                  columns={columns}
                  tableData={apps}
                  rowComponent={AppsTableCell}
                  loading={isLoading}
                  hideSearch={false}
                  defaultSortIndex={0}
                  setTableData={undefined}
                  reverse={false}
                  customProps={undefined}
                />
              </Box>
            </Box>
          </Paper>
          <Modal
            fullWidth
            maxWidth="sm"
            open={modalStatus.open === true}
            title={createAppModalTitle}
            hasLoadingBar={true}
            isProcessing={createIsLoading}
            handleClose={() => handleCreateModalClose()}
          >
            <ModalForm formik={formik} isProcessing={createIsLoading}>
              <CreateAppForm />
            </ModalForm>
          </Modal>
        </PageContainer>
      </>
    )
  );
}
